import dayjs from "dayjs";
import React, { useState } from "react";
import { UtilService } from "src/util/util.service";

function useStartDateEndDatePickerFields() {
  const [values, setValues] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const handleRangePicker = (moments, dateStrings) => {
    setValues(dateStrings);
  };

  const onOpenChange = (open) => {
    setIsOpen(open);
  };

  const convertedStartDate = UtilService.dateRangePickerFormatedDate(values[0]);
  const convertedEndDate = UtilService.dateRangePickerFormatedDate(values[1], "23:59:00");

  return {
    values,
    isOpen,
    handleRangePicker,
    onOpenChange,
    convertedStartDate,
    convertedEndDate,
  };
}

export default useStartDateEndDatePickerFields;
